<template>
  <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.5 16.75C12.9518 16.75 15.75 13.9518 15.75 10.5C15.75 7.04822 12.9518 4.25 9.5 4.25C6.04822 4.25 3.25 7.04822 3.25 10.5C3.25 13.9518 6.04822 16.75 9.5 16.75Z"
        stroke="#8E8E93" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.5 6.75V10.5L12 11.75" stroke="#8E8E93" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'timeIcon',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
